import { react2angular } from 'react2angular';
import AppointmentRestrictions from './AppointmentRestrictions';

angular
  .module('bb.appointments')
  .component(
    'bbAppointmentRestrictions',
    react2angular(AppointmentRestrictions, [
      'timeSelection',
      'selectTimes',
      'specialDays',
      'unavailableDays',
      'updateSpecialDays',
      'disableAutoConfirm',
      'noMoreShowings',
      'autoConfirm',
      'access',
      'supraLockbox',
      'supraLockboxAccessHours',
      'supraLockboxRestrictedHoursMap',
      'updateLockboxHours',
      'listingTimezone',
    ]),
  );
